import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
query getOrganisationalSummary(
$businessId: ID!,
$category: OrganisationalSummaryCategory,
$teams: [ID],
$duration: OrganisationalSummaryDuration,
$trendRateDuration: OrganisationalSummaryTrendDuration) {
  organisationalSummary(
  businessId: $businessId, category: $category, teams: $teams, duration: $duration, trendRateDuration: $trendRateDuration) {
    main {
      loginRate {
        value
      }
      engagementRate {
        value
      }
      numberOfEngagedUsers {
        value
      }
      numberOfEngagements {
        value
      }
      savingsGBP {
        value
      }
      savingsPercentage {
        value
      }
      savingsAUD {
        value
      }
      trends {
        date {
          year {
            value
          }
          month {
            value
          }
          quarter {
            value
          }
        }
        numberOfActivatedUsers {
          value
        }
        numberOfEngagedUsers {
          value
        }
        numberOfUsersLoggedIn {
          value
        }
        numberOfEngagements {
          value
        }
        savingsGBP {
          value
        }
        savingsPercentage {
          value
        }
        savingsAUD {
          value
        }
      }
    }
    perks{
      engagementRate {
        value
      }
      redemptions {
        value
      }
      usersRedeemed {
        value
      }
      savingsGBP {
        value
      }
      savingsPercentage {
        value
      }
      savingsAUD {
        value
      }
      trends {
        date {
          year {
            value
          }
          month {
            value
          }
          quarter {
            value
          }
        }
        redemptions {
          value
        }
        usersRedeemed {
          value
        }
        savingsGBP {
          value
        }
        savingsPercentage {
          value
        }
        savingsAUD {
          value
        }
        numberOfActivatedUsers {
          value
        }
      }
    }
    flexi{
      engagementRate {
        value
      }
      redemptions {
        value
      }
      usersRedeemed {
        value
      }
      earned {
        value
      }
      burned {
        value
      }
      savingsGBP {
        value
      }
      savingsAUD {
        value
      }
      trends {
        date {
          year {
            value
          }
          month {
            value
          }
          quarter {
            value
          }
        }
        redemptions {
          value
        }
        usersRedeemed {
          value
        }
        earned {
          value
        }
        burned {
          value
        }
        savingsGBP {
          value
        }
        savingsAUD {
          value
        }
        numberOfActivatedUsers {
          value
        }
      }
    }
    celebrations {
      engagementRate {
        value
      }
      usersEngaged {
        value
      }
      recognitions {
        value
      }
      polls {
        value
      }
      rewardPointsGiven {
        value
      }
      rewardPointsPurchased {
        value
      }
      trends {
        date {
          year {
            value
          }
          month {
            value
          }
          quarter {
            value
          }
        }
        usersEngaged {
          value
        }
        recognitions {
          value
        }
        polls {
          value
        }
        rewardPointsGiven {
          value
        }
        rewardPointsPurchased {
          value
        }
        usersGivenRecognition {
          value
        }
        usersReceivedRecognition {
          value
        }
        numberOfActivatedUsers {
          value
        }
      }
    }
    wellness {
      engagementRate {
        value
      }
      usersEngaged {
        value
      }
      views {
        value
      }
      webinarRegistrations {
        value
      }
      trends {
        date {
          year {
            value
          }
          month {
            value
          }
          quarter {
            value
          }
        }
        usersEngaged {
          value
        }
        views {
          value
        }
        webinarRegistrations {
          value
        }
        numberOfActivatedUsers {
          value
        }
      }
    }
  }
}
`

export const organisationalSummaryKey = getQueryNames(query)[0]

export default query
